import React, { useEffect, useState, } from 'react'
import { useSelector, useDispatch, } from 'react-redux'
import { Helmet, } from "react-helmet"
import { appName, } from '../../../../constants'
import Loading from '../../../layouts/Loading'
import FeatureSlideshow from '../../../layouts/FeatureSlideshow'
import BackButton from '../../../layouts/BackButton'
import { addPaymentMethodAction, } from '../../../../redux/actions/addPaymentMethodActions'

import "./AddPaymentMethodComponent.scss"
import ErrorComponent from '../../../layouts/ErrorComponent'

export default function AddPaymentMethodComponent() {
  const [cardNumber, setCardNumber] = useState("")
  const [expiryDate, setExpiryDate] = useState("")
  const [cvv, setCvv] = useState("")
  const [cardHoldersName, setCardHoldersName] = useState("")
  
  const [loading, setLoading] = useState(true)

  const [error, setError] = useState("")
  
  const [showFeatureSlideshow, setShowFeatureSlideshow] = useState(true)

  const dispatch = useDispatch()

  const state = useSelector(state => ({
    auth: state.auth,
    addPaymentMethod: state.addPaymentMethod,
  }))

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 1400) {
        setShowFeatureSlideshow(false)
      } else {
        setShowFeatureSlideshow(true)
      }
    }
    window.addEventListener('resize', handleResize)

    handleResize()
    setLoading(false)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    if (false === state.addPaymentMethod.loading) {
      setLoading(false)
    }
    if (state.addPaymentMethod.error) {
      setError(state.addPaymentMethod.error)
    }
    if (state.addPaymentMethod.data) {
      setCardNumber("")
      setExpiryDate("")
      setCvv("")
      setCardHoldersName("")

      window.location = "/user/payment-methods"
    }
  }, [state.addPaymentMethod])
  
  const onFormSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    const expiryRegex = /^(0[1-9]|1[0-2])\/([0-9]{2})$/
    const payload = {}

    if (!cardNumber) {
      setLoading(false)
      return setError("The card number field is missing.")
    }
    if (expiryDate && null === expiryDate.match(expiryRegex)) {
      setLoading(false)
      return setError("The expiry date field must be in the format MM/YY.")
    }
    if (3 !== cvv.length) {
      setLoading(false)
      return setError("The CVV field is missing")
    }
    if (!cardHoldersName) {
      setLoading(false)
      return setError("The card holder's name field is missing")
    }

    payload.cardNumber = cardNumber
    payload.expiryDate = expiryDate
    payload.cvv = cvv
    payload.cardHoldersName = cardHoldersName

    dispatch(addPaymentMethodAction(payload))
  }

  const onCardNumberChange = e => {
    let result = e.target.value.trim().split(" ").join("")
    if (16 < result.length) {
      return
    }
    setCardNumber(result)
  }

  const onExpiryDateChange = e => {
    if (5 < e.target.value.length) {
      return
    }
    setExpiryDate(e.target.value)
  }

  const onCvvChange = e => {
    if (3 < e.target.value.length) {
      return
    }
    setCvv(e.target.value)
  }

  const onCardHoldersNameChange = e => {
    setCardHoldersName(e.target.value)
  }

  if (state.auth.loading || loading) {
    return <>
      <Helmet>
        <title>Add Payment Method - {appName}</title>
      </Helmet>
      <div className="container add-payment-methods-container text-center mt-9 mb-8">
        <Loading />
      </div>
    </>
  }

  return (
    <>
      <Helmet>
        <title>Add Payment Method - {appName}</title>
      </Helmet>
      <div className='container add-payment-methods-container py-7 py-lg-10'>
        <BackButton/>
        <div className="row">
          <div className="col-md-6">
            <h3 className="lead add-payment-methods-title">ADD CREDIT CARD</h3>
            <div className="payment-methods-sub-title">Add Payment Method to Continue!</div>
            <ErrorComponent error={state.auth.error || error} />
            <form
              method="post"
              onSubmit={onFormSubmit}
              className="add-payment-methods-form"
            >
              <ErrorComponent error={state.auth.error} />
              <div className="form-group">
                <label htmlFor="cardNumber">
                  Card Number
                </label>
                <input
                  name="cardNumber"
                  className="form-control"
                  value={cardNumber}
                  onChange={onCardNumberChange}
                  placeholder="Enter number here..."
                />
              </div>
              <div className="form-group expiry-date-container">
                <label htmlFor="expiryDate">
                  Expiry Date
                </label>
                <input
                  name="expiryDate"
                  className="form-control"
                  value={expiryDate}
                  onChange={onExpiryDateChange}
                  placeholder="MM/YY"
                />
              </div>
              <div className="form-group cvv-container">
                <label htmlFor="expiryDate">
                  CVV
                </label>
                <input
                  name="cvv"
                  className="form-control"
                  value={cvv}
                  onChange={onCvvChange}
                  placeholder="000"
                />
              </div>
              <div className="form-group">
                <label htmlFor="cardHoldersName">
                  Card Holder's Name
                </label>
                <input
                  name="cardHoldersName"
                  className="form-control"
                  value={cardHoldersName}
                  onChange={onCardHoldersNameChange}
                  placeholder="Enter name here..."
                />
              </div>
              <div className="add-payment-methods-btn-container d-grid">
                <input 
                  type="submit"
                  className="btn btn-success joystick-success" 
                  value="ADD PAYMENT METHOD"
                />
              </div>
            </form>
          </div>
          {showFeatureSlideshow && (
            <div className="col-md-6">
              <FeatureSlideshow/>
            </div>
          )}
        </div>
      </div>
    </>       
  )
}
